module.exports = __webpack_public_path__ + "c621ef3555b9ffb9fc8685d08f15b9c2.MP3";